import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const VendorGoogleFinalizeForm = ({ profile, onChange, onSubmit, onCancel, submitting }) => (
  <form onSubmit={onSubmit} className="space-y-3" data-testid="vendor-google-finalize-form">
    <div className="flex items-center gap-3 bg-blue-50 border border-blue-200 rounded p-3">
      {profile.picture && <img src={profile.picture} alt="" className="w-10 h-10 rounded-full" />}
      <div className="text-xs">
        <div className="font-semibold text-gray-800">Continuing as {profile.email}</div>
        <div className="text-gray-600">Tell us about your business to finish signup.</div>
      </div>
    </div>
    <div>
      <Label className="text-xs">Company Name *</Label>
      <Input value={profile.company_name} onChange={(e) => onChange({ ...profile, company_name: e.target.value })} data-testid="gp-company-name" />
    </div>
    <div>
      <Label className="text-xs">Contact Person</Label>
      <Input value={profile.contact_name} onChange={(e) => onChange({ ...profile, contact_name: e.target.value })} data-testid="gp-contact-name" />
    </div>
    <div>
      <Label className="text-xs">Mobile *</Label>
      <div className="flex gap-2 mt-1">
        <div className="flex items-center px-3 border rounded-md bg-gray-50 text-sm">+91</div>
        <Input value={profile.mobile} onChange={(e) => onChange({ ...profile, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })} maxLength={10} data-testid="gp-mobile" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div>
        <Label className="text-xs">City *</Label>
        <Input value={profile.city} onChange={(e) => onChange({ ...profile, city: e.target.value })} data-testid="gp-city" />
      </div>
      <div>
        <Label className="text-xs">Year Established</Label>
        <Input type="number" value={profile.year_established} onChange={(e) => onChange({ ...profile, year_established: e.target.value })} data-testid="gp-year" />
      </div>
    </div>
    <div>
      <Label className="text-xs">GST Number</Label>
      <Input value={profile.gst_number} onChange={(e) => onChange({ ...profile, gst_number: e.target.value.toUpperCase() })} maxLength={15} data-testid="gp-gst" />
    </div>
    <Button type="submit" disabled={submitting} className="w-full bg-[#ee5e23] hover:bg-[#d24e15] text-white h-11" data-testid="gp-submit">
      {submitting ? 'Submitting...' : 'Finish vendor signup'}
    </Button>
    <button type="button" onClick={onCancel} className="text-xs text-[#2c54b2] hover:underline w-full">Cancel</button>
  </form>
);

export default VendorGoogleFinalizeForm;
